import { render } from "./ProfileTestHistory.vue?vue&type=template&id=7aeff440"
import script from "./ProfileTestHistory.vue?vue&type=script&lang=js"
export * from "./ProfileTestHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__